// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * This injects Tailwind's base styles and any base styles registered by
 * plugins.
 */
/*! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
 */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
[type='text'],input:where(:not([type])),[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select {
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 rgba(0,0,0,0);
}
[type='text']:focus, input:where(:not([type])):focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}
input::placeholder,textarea::placeholder {
  color: #6b7280;
  opacity: 1;
}
::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}
::-webkit-date-and-time-value {
  min-height: 1.5em;
  text-align: inherit;
}
::-webkit-datetime-edit {
  display: inline-flex;
}
::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field {
  padding-top: 0;
  padding-bottom: 0;
}
select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
[multiple],[size]:where(select:not([size="1"])) {
  background-image: initial;
  background-position: initial;
  background-repeat: initial;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: inherit;
          print-color-adjust: inherit;
}
[type='checkbox'],[type='radio'] {
  -webkit-appearance: none;
          appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 rgba(0,0,0,0);
}
[type='checkbox'] {
  border-radius: 0px;
}
[type='radio'] {
  border-radius: 100%;
}
[type='checkbox']:focus,[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
[type='checkbox']:checked,[type='radio']:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
[type='checkbox']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@media (forced-colors: active)  {
  [type='checkbox']:checked {
    -webkit-appearance: auto;
            appearance: auto;
  }
}
[type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@media (forced-colors: active)  {
  [type='radio']:checked {
    -webkit-appearance: auto;
            appearance: auto;
  }
}
[type='checkbox']:checked:hover,[type='checkbox']:checked:focus,[type='radio']:checked:hover,[type='radio']:checked:focus {
  border-color: transparent;
  background-color: currentColor;
}
[type='checkbox']:indeterminate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
@media (forced-colors: active)  {
  [type='checkbox']:indeterminate {
    -webkit-appearance: auto;
            appearance: auto;
  }
}
[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}
[type='file'] {
  background: initial;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: inherit;
  line-height: inherit;
}
[type='file']:focus {
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}
body.reduce-motion * {
  transition-property: none !important;
  transition-duration: 0ms !important;
}
body.dark {
    color-scheme: dark;
  }
body:not(.dark) {
    color-scheme: light;
  }
body.no-rounded-corners *:not(.rounded-full) {
  border-radius: 0px !important;
}
*::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(156, 163, 175, var(--tw-placeholder-opacity));
}
* {
  --tw-ring-inset: inset !important;
}
* {
  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-duration: 150ms;
  transition-duration: var(--transition-duration);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
:is(.dark *) {
  --tw-shadow: 0 0 rgba(0,0,0,0) !important;
  --tw-shadow-colored: 0 0 rgba(0,0,0,0) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow) !important;
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow) !important;
}
* {
    /*
     * Disables transitions for text color.
     * See https://github.com/specify/specify7/issues/1561
     */
    transition-property: background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color,
      -webkit-backdrop-filter;
    transition-property: background-color, border-color, text-decoration-color,
      fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: background-color, border-color, text-decoration-color,
      fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color,
      -webkit-backdrop-filter;
  }
[type='text'],
  [type='email'],
  [type='url'],
  [type='password'],
  [type='number'],
  [type='date'],
  [type='datetime-local'],
  [type='month'],
  [type='search'],
  [type='tel'],
  [type='time'],
  [type='week'],
  [multiple],
  textarea,
  .textarea-shadow,
  select {
  border-radius: 0.375rem;
  border-style: none;
  background-color: var(--field-background);
  padding: 0.25rem;
  font-size: inherit;
  line-height: inherit;
  accent-color: var(--accent-color-200);
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(156, 163, 175, var(--tw-ring-opacity));
}
:is(.dark [type='text']),:is(.dark 
  [type='email']),:is(.dark 
  [type='url']),:is(.dark 
  [type='password']),:is(.dark 
  [type='number']),:is(.dark 
  [type='date']),:is(.dark 
  [type='datetime-local']),:is(.dark 
  [type='month']),:is(.dark 
  [type='search']),:is(.dark 
  [type='tel']),:is(.dark 
  [type='time']),:is(.dark 
  [type='week']),:is(.dark 
  [multiple]),:is(.dark 
  textarea),:is(.dark 
  .textarea-shadow),:is(.dark 
  select) {
  accent-color: var(--accent-color-400);
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.has-alt-background [type='text']:optional,.has-alt-background 
  [type='email']:optional,.has-alt-background 
  [type='url']:optional,.has-alt-background 
  [type='password']:optional,.has-alt-background 
  [type='number']:optional,.has-alt-background 
  [type='date']:optional,.has-alt-background 
  [type='datetime-local']:optional,.has-alt-background 
  [type='month']:optional,.has-alt-background 
  [type='search']:optional,.has-alt-background 
  [type='tel']:optional,.has-alt-background 
  [type='time']:optional,.has-alt-background 
  [type='week']:optional,.has-alt-background 
  [multiple]:optional,.has-alt-background 
  textarea:optional,.has-alt-background 
  .textarea-shadow:optional,.has-alt-background 
  select:optional {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
:is(.dark .has-alt-background [type='text']:optional),:is(.dark .has-alt-background 
  [type='email']:optional),:is(.dark .has-alt-background 
  [type='url']:optional),:is(.dark .has-alt-background 
  [type='password']:optional),:is(.dark .has-alt-background 
  [type='number']:optional),:is(.dark .has-alt-background 
  [type='date']:optional),:is(.dark .has-alt-background 
  [type='datetime-local']:optional),:is(.dark .has-alt-background 
  [type='month']:optional),:is(.dark .has-alt-background 
  [type='search']:optional),:is(.dark .has-alt-background 
  [type='tel']:optional),:is(.dark .has-alt-background 
  [type='time']:optional),:is(.dark .has-alt-background 
  [type='week']:optional),:is(.dark .has-alt-background 
  [multiple]:optional),:is(.dark .has-alt-background 
  textarea:optional),:is(.dark .has-alt-background 
  .textarea-shadow:optional),:is(.dark .has-alt-background 
  select:optional) {
  --tw-bg-opacity: 1;
  background-color: rgba(23, 23, 23, var(--tw-bg-opacity));
}
input:focus,
  textarea:focus,
  .textarea-shadow:focus,
  select:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
:is(.dark input:focus),:is(.dark 
  textarea:focus),:is(.dark 
  .textarea-shadow:focus),:is(.dark 
  select:focus) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
input,
  textarea,
  .textarea-shadow,
  select {

    /* Hide arrows, calendar icon and other symbols */
  }
@media print {
  input,
  textarea,
  .textarea-shadow,
  select {
    margin: 0px;
    -webkit-appearance: none;
            appearance: none;
    background-image: none;
  }
}
/* Adapted from Tailwind's styles for <select> */
input.autocomplete {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: right 0 center;
    background-repeat: no-repeat;
    background-size: 1.5em 1.5em;
    padding-right: 1.5em;
  }
:disabled:not(.link),
  [readonly] {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(107, 114, 128, var(--tw-ring-opacity));
}
:is(.dark :disabled:not(.link)),:is(.dark 
  [readonly]) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
select:disabled,
  input[role='combox']:disabled {
  cursor: default;
}
:is(:disabled, [readonly]):not(.link):not([type='checkbox']):not([type='radio']) {
  background-color: var(--disabled-field-background);
  --tw-text-opacity: 1;
  color: rgba(55, 65, 81, var(--tw-text-opacity));
}
:is(.dark :is(:disabled, [readonly]):not(.link):not([type='checkbox']):not([type='radio'])) {
  --tw-text-opacity: 1;
  color: rgba(115, 115, 115, var(--tw-text-opacity));
}
select[size] {
  background-image: none;
  padding-left: 0.5rem;
  padding-right: 0.25rem;
}
[type='checkbox'],
  [type='radio'] {
  cursor: pointer;
  color: var(--accent-color-200);
}
[type='checkbox']:focus,
  [type='radio']:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0)) !important;
  --tw-ring-offset-width: 0px !important;
}
[type='checkbox']:focus,
  [type='radio']:focus {
  border-style: none;
}
:is(.dark [type='checkbox']),:is(.dark 
  [type='radio']) {
  color: var(--accent-color-400);
}
:is([type='checkbox'], [type='radio']):is([readonly], :disabled) {
  cursor: default;
  --tw-bg-opacity: 1;
  background-color: rgba(209, 213, 219, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}
:is([type='checkbox'], [type='radio']):is([readonly], :disabled):checked {
  background-color: currentColor;
}
:is([type='checkbox'], [type='radio']):is([readonly], :disabled):hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(107, 114, 128, var(--tw-ring-opacity));
}
:is(.dark :is([type='checkbox'], [type='radio']):is([readonly], :disabled)) {
  --tw-bg-opacity: 1;
  background-color: rgba(82, 82, 82, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(23, 23, 23, var(--tw-text-opacity));
}
label,
  summary {
  cursor: pointer;
}
form:not(.not-submitted) :is(input, select, textarea):invalid,
  :is(input, select, textarea):not(.not-touched):invalid {
  background-color: var(--invalid-field-background) !important;
}
form:not(.not-submitted) :is(input, select, textarea):invalid::placeholder,
  :is(input, select, textarea):not(.not-touched):invalid::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(127, 29, 29, var(--tw-placeholder-opacity));
}
:is(.dark form:not(.not-submitted) :is(input, select, textarea):invalid)::placeholder,:is(.dark 
  :is(input, select, textarea):not(.not-touched):invalid)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(248, 113, 113, var(--tw-placeholder-opacity));
}
textarea,
  .textarea-shadow {
  width: 100%;
  resize: both;
}
:required {
  background-color: var(--required-field-background);
}
/* Hide up/down arrows in Gecko */
[type='number'].no-arrows {
    -moz-appearance: textfield;
  }
/* Hide up/down arrows in Webkit */
[type='number'].no-arrows::-webkit-outer-spin-button,
  [type='number'].no-arrows::-webkit-inner-spin-button {
  margin: 0px;
  -webkit-appearance: none;
          appearance: none;
}
/* Always show spinner buttons */
[type='number']:not([readonly]):not(.no-arrows)::-webkit-inner-spin-button,
  [type='number']:not([readonly]):not(.no-arrows)::-webkit-outer-spin-button {
  opacity: 1;
}
/* Make spinner buttons larger */
[type='number']:not([readonly]):not(.no-arrows)::-webkit-outer-spin-button,
  [type='number']:not([readonly]):not(.no-arrows)::-webkit-inner-spin-button {
    -webkit-appearance: inner-spin-button !important;
  }
[type='number']:not([readonly]):not(.no-arrows)::-webkit-outer-spin-button,
  [type='number']:not([readonly]):not(.no-arrows)::-webkit-inner-spin-button {
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100%;
    width: 0.5rem;
  }
[type='number']:not([readonly]):not(.no-arrows) {
  position: relative;
  padding-right: 1rem;
}
.button {
  text-align: center;
}
.button:is([aria-pressed='true'], [aria-selected='true'], [aria-current]):not(
      .aria-handled
    ) {
  --tw-ring-color: var(--accent-color-300);
  --tw-brightness: brightness(1.2);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
:is(.dark .button:is([aria-pressed='true'], [aria-selected='true'], [aria-current]):not(
      .aria-handled
    )) {
  --tw-brightness: brightness(1.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
button[aria-pressed='true']:not(.aria-handled).link {
  background-color: transparent !important;
}
button[aria-pressed='true']:not(.aria-handled).link {
  color: var(--accent-color-300);
}
:is(.dark button[aria-pressed='true']:not(.aria-handled).link) {
  color: var(--accent-color-400);
}
a.button {
  text-align: center;
}
.link {
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  gap: 0.5rem;
  text-align: left;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.link:active {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}
.link:hover:enabled {
  color: var(--accent-color-300);
}
.link:disabled {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0)) !important;
}
.link:disabled {
  cursor: text;
}
.link:active:disabled {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}
:is(.dark .link) {
  --tw-text-opacity: 1;
  color: rgba(229, 231, 235, var(--tw-text-opacity));
}
a.link:hover {
  color: var(--accent-color-400);
}
:is(.dark a.link:hover) {
  color: var(--accent-color-300);
}
.link[aria-current]:not(.aria-handled) {
  color: var(--accent-color-300);
}
.icon:active {
  background-color: var(--accent-color-100);
}
.icon:disabled {
  cursor: not-allowed !important;
  --tw-text-opacity: 1 !important;
  color: rgba(156, 163, 175, var(--tw-text-opacity)) !important;
}
.icon:hover:disabled {
  --tw-text-opacity: 1 !important;
  color: rgba(156, 163, 175, var(--tw-text-opacity)) !important;
}
:is(.dark .icon:active) {
  background-color: var(--accent-color-500);
}
:is(.dark .icon):disabled {
  --tw-text-opacity: 1 !important;
  color: rgba(82, 82, 82, var(--tw-text-opacity)) !important;
}
:is(.dark .icon):hover:disabled {
  --tw-text-opacity: 1 !important;
  color: rgba(82, 82, 82, var(--tw-text-opacity)) !important;
}
progress::-webkit-progress-bar {
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}
:is(.dark progress)::-webkit-progress-bar {
  --tw-bg-opacity: 1;
  background-color: rgba(64, 64, 64, var(--tw-bg-opacity));
}
progress::-webkit-progress-value {
  border-radius: 0.375rem;
  background-color: var(--accent-color-200);
}
:is(.dark progress)::-webkit-progress-value {
  background-color: var(--accent-color-400);
}
progress::-moz-progress-bar {
  border-radius: 0.375rem;
  background-color: var(--accent-color-200);
}
:is(.dark progress)::-moz-progress-bar {
  background-color: var(--accent-color-400);
}
/*
   * Grid-based table implementation for increased flexibility
   * Does not sacrifice accessibility thanks to the [role] attributes
   * Allows for things like sticky headers and having entire row be a link/button
   * You can set column sizes by adding a className like this:
   *   grid-cols-[repeat(4,1fr)_auto_auto_min-content_minmax(10rem,1fr)]
   * There is much more flexibility in how columns should be sized.
   */
.grid-table:is(table, [role~='table']) {
  display: grid;
}
.grid-table :is(thead, tbody, tr, [role~='rowgroup'], [role~='row']) {
  display: contents;
}
.grid-table
    :is(th, td, [role~='columnheader'], [role~='rowheader'], [role~='cell']) {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
/*
   * Without this, sr-only elements where causing scroll bars to appear in
   * some browsers
   */
.sr-only {
  top: 0px;
}
optgroup {
  font-weight: 700;
}
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

/*
 * REFACTOR: get rid of most global styles once everything is using React components
 *   (can use arbitrary variants too)
 * REFACTOR: remove most usages of !important after global styles are removed
 * REFACTOR: split this into smaller files
 */

/**
 * This injects Tailwind's component classes and any component classes
 * registered by plugins.
 */
.container {
  width: 100%;
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}
.wbs-form {
    --new-cell: hsl(232, 92%, 79%);
    --invalid-cell: #fca5a5;
    --modified-cell: hsl(53, 98%, 72%);
    --search-result: #86efac;
    --updated-cell: #a5f3fc;
    --deleted-cell: #f59e0b;
    --matched-and-changed-cell: #bfdbfe;
  }
:is(.dark .wbs-form) {
  --deleted-cell: #d97706;
  --invalid-cell: #7f1d1d;
  --matched-and-changed-cell: #a21caf;
  --modified-cell: #713f12;
  --new-cell: #312e81;
  --search-result: #14532d;
  --updated-cell: #155e75;
}
.custom-select {
    --custom-select-b1: #fff;
    --custom-select-b2: var(--accent-color-100);
    --custom-select-accent: var(--accent-color-100);
  }
:is(.dark .custom-select) {
  --custom-select-accent: var(--accent-color-500);
  --custom-select-b1: #262626;
  --custom-select-b2: var(--accent-color-500);
}
.custom-select-group-required-fields,
  .custom-select-input-required {
    --custom-select-b1: #cffafe;
    --custom-select-b2: #a5f3fc;
    --custom-select-accent: #67e8f9;
  }
:is(.dark .custom-select-group-required-fields),:is(.dark 
  .custom-select-input-required) {
  --custom-select-accent: #0e7490;
  --custom-select-b1: #164e63;
  --custom-select-b2: #155e75;
}
.custom-select-group-hidden-fields,
  .custom-select-input-hidden {
    --custom-select-b1: #e5e7eb;
    --custom-select-b2: #d1d5db;
    --custom-select-accent: hsl(218, 12%, 79%);
  }
:is(.dark .custom-select-group-hidden-fields),:is(.dark 
  .custom-select-input-hidden) {
  --custom-select-b1: #262626;
  --custom-select-accent: #525252;
  --custom-select-b2: #404040;
}

/**
 * This injects Tailwind's utility classes and any utility classes registered
 * by plugins.
 */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.\\!fixed {
  position: fixed !important;
}
.fixed {
  position: fixed;
}
.\\!absolute {
  position: absolute !important;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.\\!top-\\[unset\\] {
  top: initial !important;
}
.-left-2 {
  left: -0.5rem;
}
.bottom-0 {
  bottom: 0px;
}
.left-0 {
  left: 0px;
}
.left-3 {
  left: 0.75rem;
}
.right-0 {
  right: 0px;
}
.right-3 {
  right: 0.75rem;
}
.top-0 {
  top: 0px;
}
.top-3 {
  top: 0.75rem;
}
.top-\\[unset\\] {
  top: initial;
}
.z-10 {
  z-index: 10;
}
.z-50 {
  z-index: 50;
}
.z-\\[-1\\] {
  z-index: -1;
}
.z-\\[10000\\] {
  z-index: 10000;
}
.z-\\[10\\] {
  z-index: 10;
}
.z-\\[20\\] {
  z-index: 20;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[3\\] {
  z-index: 3;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-7 {
  grid-column: span 7 / span 7;
}
.col-span-full {
  grid-column: 1 / -1;
}
.\\!m-0 {
  margin: 0px !important;
}
.-m-1 {
  margin: -0.25rem;
}
.-m-4 {
  margin: -1rem;
}
.m-2 {
  margin: 0.5rem;
}
.m-4 {
  margin: 1rem;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.-mb-\\[12px\\] {
  margin-bottom: -12px;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-ml-2 {
  margin-left: -0.5rem;
}
.-ml-4 {
  margin-left: -1rem;
}
.-ml-\\[5px\\] {
  margin-left: -5px;
}
.-mr-2 {
  margin-right: -0.5rem;
}
.-mt-2 {
  margin-top: -0.5rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.\\!block {
  display: block !important;
}
.block {
  display: block;
}
.\\!inline {
  display: inline !important;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.\\!table {
  display: table !important;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.inline-grid {
  display: inline-grid;
}
.contents {
  display: contents;
}
.list-item {
  display: list-item;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.\\!h-44 {
  height: 11rem !important;
}
.\\!h-full {
  height: 100% !important;
}
.h-0 {
  height: 0px;
}
.h-1\\/2 {
  height: 50%;
}
.h-20 {
  height: 5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-44 {
  height: 11rem;
}
.h-5\\/6 {
  height: 83.333333%;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[1\\.5em\\] {
  height: 1.5em;
}
.h-\\[473px\\] {
  height: 473px;
}
.h-\\[60rem\\] {
  height: 60rem;
}
.h-\\[70vh\\] {
  height: 70vh;
}
.h-\\[779px\\] {
  height: 779px;
}
.h-\\[theme\\(spacing\\.14\\)\\] {
  height: 3.5rem;
}
.h-\\[theme\\(spacing\\.40\\)\\] {
  height: 10rem;
}
.h-\\[var\\(--mapping-view-height\\)\\] {
  height: var(--mapping-view-height);
}
.h-auto {
  height: auto;
}
.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.h-table-icon {
  height: 1.25rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-80 {
  max-height: 20rem;
}
.max-h-\\[50\\%\\] {
  max-height: 50%;
}
.max-h-\\[50vh\\] {
  max-height: 50vh;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[90\\%\\] {
  max-height: 90%;
}
.max-h-\\[theme\\(spacing\\.16\\)\\] {
  max-height: 4rem;
}
.max-h-\\[theme\\(spacing\\.24\\)\\] {
  max-height: 6rem;
}
.max-h-\\[theme\\(spacing\\.5\\)\\] {
  max-height: 1.25rem;
}
.max-h-\\[theme\\(spacing\\.64\\)\\] {
  max-height: 16rem;
}
.max-h-\\[theme\\(spacing\\.96\\)\\] {
  max-height: 24rem;
}
.max-h-full {
  max-height: 100%;
}
.max-h-screen {
  max-height: 100vh;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-60 {
  min-height: 15rem;
}
.min-h-\\[30vh\\] {
  min-height: 30vh;
}
.min-h-\\[calc\\(theme\\(spacing\\.7\\)\\*var\\(--rows\\)\\)\\] {
  min-height: calc(1.75rem * var(--rows));
}
.min-h-\\[theme\\(spacing\\.40\\)\\] {
  min-height: 10rem;
}
.min-h-\\[theme\\(spacing\\.60\\)\\] {
  min-height: 15rem;
}
.min-h-\\[theme\\(spacing\\.8\\)\\] {
  min-height: 2rem;
}
.min-h-\\[theme\\(spacing\\.80\\)\\] {
  min-height: 20rem;
}
.\\!w-16 {
  width: 4rem !important;
}
.\\!w-56 {
  width: 14rem !important;
}
.\\!w-80 {
  width: 20rem !important;
}
.\\!w-\\[unset\\] {
  width: initial !important;
}
.\\!w-auto {
  width: auto !important;
}
.\\!w-fit {
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-0 {
  width: 0px;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-20 {
  width: 5rem;
}
.w-3 {
  width: 0.75rem;
}
.w-32 {
  width: 8rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[1\\.5em\\] {
  width: 1.5em;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[800px\\] {
  width: 800px;
}
.w-\\[947px\\] {
  width: 947px;
}
.w-\\[inherit\\] {
  width: inherit;
}
.w-\\[min\\(30rem\\2c 90\\%\\)\\] {
  width: min(30rem,90%);
}
.w-\\[min\\(40rem\\2c 50vw\\)\\] {
  width: min(40rem,50vw);
}
.w-\\[min\\(60rem\\2c 90\\%\\)\\] {
  width: min(60rem,90%);
}
.w-\\[unset\\] {
  width: initial;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-screen {
  width: 100vw;
}
.w-table-icon {
  width: 1.25rem;
}
.min-w-96 {
  min-width: 24rem;
}
.min-w-\\[30vh\\] {
  min-width: 30vh;
}
.min-w-\\[35rem\\] {
  min-width: 35rem;
}
.min-w-\\[50\\%\\] {
  min-width: 50%;
}
.min-w-\\[min\\(20rem\\2c 90\\%\\)\\] {
  min-width: min(20rem,90%);
}
.min-w-\\[min\\(30rem\\2c 90\\%\\)\\] {
  min-width: min(30rem,90%);
}
.min-w-\\[min\\(40rem\\2c 90\\%\\)\\] {
  min-width: min(40rem,90%);
}
.min-w-\\[theme\\(spacing\\.20\\)\\] {
  min-width: 5rem;
}
.min-w-\\[theme\\(spacing\\.24\\)\\] {
  min-width: 6rem;
}
.min-w-\\[theme\\(spacing\\.40\\)\\] {
  min-width: 10rem;
}
.min-w-\\[theme\\(spacing\\.60\\)\\] {
  min-width: 15rem;
}
.min-w-fit {
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.min-w-max {
  min-width: max-content;
}
.max-w-\\[1000px\\] {
  max-width: 1000px;
}
.max-w-\\[25vw\\] {
  max-width: 25vw;
}
.max-w-\\[30rem\\] {
  max-width: 30rem;
}
.max-w-\\[50\\%\\] {
  max-width: 50%;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[theme\\(spacing\\.10\\)\\] {
  max-width: 2.5rem;
}
.max-w-\\[theme\\(spacing\\.16\\)\\] {
  max-width: 4rem;
}
.max-w-\\[theme\\(spacing\\.24\\)\\] {
  max-width: 6rem;
}
.max-w-\\[theme\\(spacing\\.96\\)\\] {
  max-width: 24rem;
}
.max-w-\\[unset\\] {
  max-width: initial;
}
.max-w-\\[var\\(--form-max-width\\)\\] {
  max-width: var(--form-max-width);
}
.max-w-\\[var\\(--max-field-width\\)\\] {
  max-width: var(--max-field-width);
}
.max-w-fit {
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.max-w-full {
  max-width: 100%;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\!transform-none {
  transform: none !important;
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }
  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
.\\!cursor-auto {
  cursor: auto !important;
}
.\\!cursor-not-allowed {
  cursor: not-allowed !important;
}
.\\!cursor-pointer {
  cursor: pointer !important;
}
.cursor-auto {
  cursor: auto;
}
.cursor-move {
  cursor: move;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.snap-y {
  scroll-snap-type: y var(--tw-scroll-snap-strictness);
}
.snap-proximity {
  --tw-scroll-snap-strictness: proximity;
}
.snap-start {
  scroll-snap-align: start;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.auto-rows-auto {
  grid-auto-rows: auto;
}
.auto-rows-max {
  grid-auto-rows: max-content;
}
.auto-rows-min {
  grid-auto-rows: min-content;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-\\[1fr_auto_1fr\\] {
  grid-template-columns: 1fr auto 1fr;
}
.grid-cols-\\[1fr_auto_auto_auto\\] {
  grid-template-columns: 1fr auto auto auto;
}
.grid-cols-\\[1fr_auto_auto_min-content\\] {
  grid-template-columns: 1fr auto auto min-content;
}
.grid-cols-\\[1fr_auto_min-content_min-content\\] {
  grid-template-columns: 1fr auto min-content min-content;
}
.grid-cols-\\[1fr_minmax\\(12rem\\2c 1fr\\)_1fr\\] {
  grid-template-columns: 1fr minmax(12rem,1fr) 1fr;
}
.grid-cols-\\[2fr_1fr\\] {
  grid-template-columns: 2fr 1fr;
}
.grid-cols-\\[auto\\2c auto\\2c 1fr\\2c auto\\] {
  grid-template-columns: auto auto 1fr auto;
}
.grid-cols-\\[auto\\2c auto\\] {
  grid-template-columns: auto auto;
}
.grid-cols-\\[auto\\2c repeat\\(var\\(--columns\\)\\2c minmax\\(15rem\\2c 1fr\\)\\)\\] {
  grid-template-columns: auto repeat(var(--columns),minmax(15rem,1fr));
}
.grid-cols-\\[auto_1fr\\] {
  grid-template-columns: auto 1fr;
}
.grid-cols-\\[auto_1fr_auto\\] {
  grid-template-columns: auto 1fr auto;
}
.grid-cols-\\[auto_1fr_auto_1fr_auto\\] {
  grid-template-columns: auto 1fr auto 1fr auto;
}
.grid-cols-\\[auto_1fr_max-content\\] {
  grid-template-columns: auto 1fr max-content;
}
.grid-cols-\\[auto_auto\\] {
  grid-template-columns: auto auto;
}
.grid-cols-\\[auto_auto_auto\\] {
  grid-template-columns: auto auto auto;
}
.grid-cols-\\[auto_auto_auto_auto\\] {
  grid-template-columns: auto auto auto auto;
}
.grid-cols-\\[auto_min-content\\] {
  grid-template-columns: auto min-content;
}
.grid-cols-\\[auto_repeat\\(var\\(--columns\\)\\2c auto\\)\\] {
  grid-template-columns: auto repeat(var(--columns),auto);
}
.grid-cols-\\[fit-content\\(40\\%\\)_1fr\\] {
  grid-template-columns: fit-content(40%) 1fr;
}
.grid-cols-\\[min-content_1fr_auto_min-content\\] {
  grid-template-columns: min-content 1fr auto min-content;
}
.grid-cols-\\[min-content_1fr_min-content\\] {
  grid-template-columns: min-content 1fr min-content;
}
.grid-cols-\\[min-content_repeat\\(7\\2c auto\\)\\] {
  grid-template-columns: min-content repeat(7,auto);
}
.grid-cols-\\[repeat\\(3\\2c auto\\)\\] {
  grid-template-columns: repeat(3,auto);
}
.grid-cols-\\[repeat\\(3\\2c auto\\)_min-content\\] {
  grid-template-columns: repeat(3,auto) min-content;
}
.grid-cols-\\[repeat\\(4\\2c min-content\\)_auto\\] {
  grid-template-columns: repeat(4,min-content) auto;
}
.grid-cols-\\[repeat\\(8\\2c auto\\)\\] {
  grid-template-columns: repeat(8,auto);
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(20rem\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fill,minmax(20rem,1fr));
}
.grid-cols-\\[repeat\\(var\\(--cols\\)\\2c auto\\)\\] {
  grid-template-columns: repeat(var(--cols),auto);
}
.grid-cols-\\[theme\\(spacing\\.8\\)_max-content_auto\\] {
  grid-template-columns: 2rem max-content auto;
}
.grid-rows-1 {
  grid-template-rows: repeat(1, minmax(0, 1fr));
}
.grid-rows-\\[100\\%\\] {
  grid-template-rows: 100%;
}
.grid-rows-\\[1fr_auto_1fr\\] {
  grid-template-rows: 1fr auto 1fr;
}
.grid-rows-\\[min-content_auto\\] {
  grid-template-rows: min-content auto;
}
.\\!flex-row {
  flex-direction: row !important;
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.content-center {
  align-content: center;
}
.content-start {
  align-content: flex-start;
}
.\\!items-start {
  align-items: flex-start !important;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.\\!items-stretch {
  align-items: stretch !important;
}
.items-stretch {
  align-items: stretch;
}
.\\!justify-start {
  justify-content: flex-start !important;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.\\!gap-2 {
  gap: 0.5rem !important;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(4px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(4px * var(--tw-divide-y-reverse));
}
.\\!divide-\\[color\\:var\\(--form-background\\)\\] > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--form-background) !important;
}
.divide-\\[color\\:var\\(--form-background\\)\\] > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--form-background);
}
.divide-gray-500 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgba(107, 114, 128, var(--tw-divide-opacity));
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-scroll {
  overflow: scroll;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-y-visible {
  overflow-y: visible;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.overscroll-none {
  overscroll-behavior: none;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.375rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-sm {
  border-radius: 0.25rem;
}
.rounded-xs {
  border-radius: 0.125rem;
}
.rounded-b {
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-b-none {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-l {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-r {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-t {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-tl-md {
  border-top-left-radius: 0.5rem;
}
.rounded-tr-md {
  border-top-right-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-8 {
  border-width: 8px;
}
.border-x-0 {
  border-left-width: 0px;
  border-right-width: 0px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-dotted {
  border-style: dotted;
}
.border-\\[var\\(--edge-color\\)\\] {
  border-color: var(--edge-color);
}
.border-brand-300 {
  border-color: var(--accent-color-300);
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgba(156, 163, 175, var(--tw-border-opacity));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgba(107, 114, 128, var(--tw-border-opacity));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgba(55, 65, 81, var(--tw-border-opacity));
}
.border-neutral-700 {
  --tw-border-opacity: 1;
  border-color: rgba(64, 64, 64, var(--tw-border-opacity));
}
.border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgba(249, 115, 22, var(--tw-border-opacity));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgba(239, 68, 68, var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}
.border-b-\\[color\\:var\\(--accent-color-300\\)\\] {
  border-bottom-color: var(--accent-color-300);
}
.border-b-gray-500 {
  --tw-border-opacity: 1;
  border-bottom-color: rgba(107, 114, 128, var(--tw-border-opacity));
}
.border-l-gray-500 {
  --tw-border-opacity: 1;
  border-left-color: rgba(107, 114, 128, var(--tw-border-opacity));
}
.border-t-gray-500 {
  --tw-border-opacity: 1;
  border-top-color: rgba(107, 114, 128, var(--tw-border-opacity));
}
.\\!bg-\\[color\\:var\\(--custom-select-accent\\)\\] {
  background-color: var(--custom-select-accent) !important;
}
.\\!bg-\\[color\\:var\\(--form-background\\)\\] {
  background-color: var(--form-background) !important;
}
.\\!bg-brand-300 {
  background-color: var(--accent-color-300) !important;
}
.bg-\\[color\\:var\\(--background\\)\\] {
  background-color: var(--background);
}
.bg-\\[color\\:var\\(--bg\\)\\] {
  background-color: var(--bg);
}
.bg-\\[color\\:var\\(--custom-select-b1\\)\\] {
  background-color: var(--custom-select-b1);
}
.bg-\\[color\\:var\\(--custom-select-b2\\)\\] {
  background-color: var(--custom-select-b2);
}
.bg-\\[color\\:var\\(--danger-button-color\\)\\] {
  background-color: var(--danger-button-color);
}
.bg-\\[color\\:var\\(--field-background\\)\\] {
  background-color: var(--field-background);
}
.bg-\\[color\\:var\\(--foreground\\)\\] {
  background-color: var(--foreground);
}
.bg-\\[color\\:var\\(--form-background\\)\\] {
  background-color: var(--form-background);
}
.bg-\\[color\\:var\\(--form-foreground\\)\\] {
  background-color: var(--form-foreground);
}
.bg-\\[color\\:var\\(--info-button-color\\)\\] {
  background-color: var(--info-button-color);
}
.bg-\\[color\\:var\\(--save-button-color\\)\\] {
  background-color: var(--save-button-color);
}
.bg-\\[color\\:var\\(--secondary-button-color\\)\\] {
  background-color: var(--secondary-button-color);
}
.bg-\\[color\\:var\\(--secondary-light-button-color\\)\\] {
  background-color: var(--secondary-light-button-color);
}
.bg-\\[color\\:var\\(--success-button-color\\)\\] {
  background-color: var(--success-button-color);
}
.bg-\\[color\\:var\\(--warning-button-color\\)\\] {
  background-color: var(--warning-button-color);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(219, 234, 254, var(--tw-bg-opacity));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(59, 130, 246, var(--tw-bg-opacity));
}
.bg-brand-100 {
  background-color: var(--accent-color-100);
}
.bg-brand-200 {
  background-color: var(--accent-color-200);
}
.bg-brand-300 {
  background-color: var(--accent-color-300);
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(16, 185, 129, var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}
.bg-gray-100\\/60 {
  background-color: rgba(243, 244, 246, 0.6);
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgba(209, 213, 219, var(--tw-bg-opacity));
}
.bg-gray-350 {
  --tw-bg-opacity: 1;
  background-color: hsla(218, 12%, 79%, var(--tw-bg-opacity));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(156, 163, 175, var(--tw-bg-opacity));
}
.bg-gray-500\\/70 {
  background-color: rgba(107, 114, 128, 0.7);
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(74, 222, 128, var(--tw-bg-opacity));
}
.bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgba(21, 128, 61, var(--tw-bg-opacity));
}
.bg-inherit {
  background-color: inherit;
}
.bg-neutral-800 {
  --tw-bg-opacity: 1;
  background-color: rgba(38, 38, 38, var(--tw-bg-opacity));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(249, 115, 22, var(--tw-bg-opacity));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 226, 226, var(--tw-bg-opacity));
}
.bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 202, 202, var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(239, 68, 68, var(--tw-bg-opacity));
}
.bg-red-700 {
  --tw-bg-opacity: 1;
  background-color: rgba(185, 28, 28, var(--tw-bg-opacity));
}
.bg-rose-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(244, 63, 94, var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.bg-white\\/40 {
  background-color: rgba(255, 255, 255, 0.4);
}
.bg-white\\/70 {
  background-color: rgba(255, 255, 255, 0.7);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 249, 195, var(--tw-bg-opacity));
}
.bg-yellow-250 {
  --tw-bg-opacity: 1;
  background-color: hsla(53, 98%, 72%, var(--tw-bg-opacity));
}
.bg-\\[linear-gradient\\(to_left\\2c var\\(--background\\)\\2c transparent\\)\\] {
  background-image: linear-gradient(to left,var(--background),transparent);
}
.bg-\\[linear-gradient\\(to_right\\2c var\\(--background\\)\\2c transparent\\)\\] {
  background-image: linear-gradient(to right,var(--background),transparent);
}
.bg-gradient-to-bl {
  background-image: linear-gradient(to bottom left, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[var\\(--edge-color\\)\\] {
  --tw-gradient-from: var(--edge-color) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(255, 255, 255, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-200 {
  --tw-gradient-from: #e5e7eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(229, 231, 235, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-400 {
  --tw-gradient-from: #fb923c var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(251, 146, 60, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-400 {
  --tw-gradient-from: #facc15 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(250, 204, 21, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[var\\(--middle-color\\)\\] {
  --tw-gradient-to: rgba(255, 255, 255, 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--middle-color) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white {
  --tw-gradient-to: rgba(255, 255, 255, 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[var\\(--edge-color\\)\\] {
  --tw-gradient-to: var(--edge-color) var(--tw-gradient-to-position);
}
.to-amber-200 {
  --tw-gradient-to: #fde68a var(--tw-gradient-to-position);
}
.to-red-400 {
  --tw-gradient-to: #f87171 var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.bg-contain {
  background-size: contain;
}
.bg-center {
  background-position: center;
}
.bg-right {
  background-position: right;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.stroke-white {
  stroke: #fff;
}
.stroke-2 {
  stroke-width: 2;
}
.object-contain {
  object-fit: contain;
}
.object-scale-down {
  object-fit: scale-down;
}
.\\!p-0 {
  padding: 0px !important;
}
.\\!p-2 {
  padding: 0.5rem !important;
}
.\\!p-4 {
  padding: 1rem !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-16 {
  padding: 4rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-\\[1\\.4vh\\] {
  padding: 1.4vh;
}
.\\!px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.\\!py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-\\[0\\.1rem\\] {
  padding-bottom: 0.1rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-\\[calc\\(theme\\(spacing\\.table-icon\\)_\\+_theme\\(spacing\\.2\\)\\)\\] {
  padding-left: calc(1.25rem + 0.5rem);
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-\\[1\\.5em\\] {
  padding-right: 1.5em;
}
.pr-\\[3\\.75rem\\] {
  padding-right: 3.75rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-\\[0\\.1rem\\] {
  padding-top: 0.1rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
.font-\\[family-name\\:var\\(--form-font-family\\)\\] {
  font-family: var(--form-font-family);
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-9xl {
  font-size: 8rem;
  line-height: 1;
}
.text-\\[length\\:var\\(--form-font-size\\)\\] {
  font-size: var(--form-font-size);
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.not-italic {
  font-style: normal;
}
.ordinal {
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.\\!text-amber-700 {
  --tw-text-opacity: 1 !important;
  color: rgba(180, 83, 9, var(--tw-text-opacity)) !important;
}
.\\!text-blue-500 {
  --tw-text-opacity: 1 !important;
  color: rgba(59, 130, 246, var(--tw-text-opacity)) !important;
}
.\\!text-blue-700 {
  --tw-text-opacity: 1 !important;
  color: rgba(29, 78, 216, var(--tw-text-opacity)) !important;
}
.\\!text-cyan-400 {
  --tw-text-opacity: 1 !important;
  color: rgba(34, 211, 238, var(--tw-text-opacity)) !important;
}
.\\!text-green-700 {
  --tw-text-opacity: 1 !important;
  color: rgba(21, 128, 61, var(--tw-text-opacity)) !important;
}
.\\!text-orange-400 {
  --tw-text-opacity: 1 !important;
  color: rgba(251, 146, 60, var(--tw-text-opacity)) !important;
}
.\\!text-red-700 {
  --tw-text-opacity: 1 !important;
  color: rgba(185, 28, 28, var(--tw-text-opacity)) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgba(255, 255, 255, var(--tw-text-opacity)) !important;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgba(59, 130, 246, var(--tw-text-opacity));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgba(30, 64, 175, var(--tw-text-opacity));
}
.text-brand-200 {
  color: var(--accent-color-200);
}
.text-brand-300 {
  color: var(--accent-color-300);
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgba(55, 65, 81, var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgba(31, 41, 55, var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgba(34, 197, 94, var(--tw-text-opacity));
}
.text-indigo-300 {
  --tw-text-opacity: 1;
  color: rgba(165, 180, 252, var(--tw-text-opacity));
}
.text-inherit {
  color: inherit;
}
.text-neutral-500 {
  --tw-text-opacity: 1;
  color: rgba(115, 115, 115, var(--tw-text-opacity));
}
.text-neutral-900 {
  --tw-text-opacity: 1;
  color: rgba(23, 23, 23, var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgba(239, 68, 68, var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgba(220, 38, 38, var(--tw-text-opacity));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgba(153, 27, 27, var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgba(133, 77, 14, var(--tw-text-opacity));
}
.underline {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}
.\\!opacity-0 {
  opacity: 0 !important;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-80 {
  opacity: 0.8;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-gray-300 {
  --tw-shadow-color: #d1d5db;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-400 {
  --tw-shadow-color: #9ca3af;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-500 {
  --tw-shadow-color: #6b7280;
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-1 {
  outline-width: 1px;
}
.outline-blue-500 {
  outline-color: #3b82f6;
}
.outline-red-500 {
  outline-color: #ef4444;
}
.\\!ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0)) !important;
}
.\\!ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0)) !important;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.\\!ring-brand-300 {
  --tw-ring-color: var(--accent-color-300) !important;
}
.ring-blue-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(59, 130, 246, var(--tw-ring-opacity));
}
.ring-brand-200 {
  --tw-ring-color: var(--accent-color-200);
}
.ring-gray-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(156, 163, 175, var(--tw-ring-opacity));
}
.ring-gray-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(107, 114, 128, var(--tw-ring-opacity));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-125 {
  --tw-brightness: brightness(1.25);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-150 {
  --tw-brightness: brightness(1.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-50 {
  --tw-brightness: brightness(.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-80 {
  --tw-brightness: brightness(.8);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-95 {
  --tw-brightness: brightness(.95);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hue-rotate-180 {
  --tw-hue-rotate: hue-rotate(180deg);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.saturate-150 {
  --tw-saturate: saturate(1.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.saturate-200 {
  --tw-saturate: saturate(2);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-0 {
  transition-duration: 0ms;
}
/*
   * Smartly inverts leaflet layer's color scheme. Source:
   * https://gist.github.com/BrendonKoz/b1df234fe3ee388b402cd8e98f7eedbd
   */
.\\[grid-area\\:1\\/1\\/2\\/2\\] {
  grid-area: 1/1/2/2;
}
.\\[inset-block-start\\:_0\\] {
  top: 0;
}
.\\[overflow-y\\:overlay\\] {
  overflow-y: overlay;
}
.\\[scrollbar-gutter\\:auto\\] {
  scrollbar-gutter: auto;
}
.\\[z-index\\:1\\] {
  z-index: 1;
}

.\\! {
  /**
   * In Chrome DevTools, in the "Element Classes" box (where you customize
   * element class names), DevTools apply the first matching class name even
   * before you started typing. The first matching happens to be !absolute,
   * which breaks the UI. This noop is a workaround for that UX issue
   */
  --dev-tools-hack: 0;
}

/* Leaflet dark mode */
:is(.dark .leaflet-bar a) {
  --tw-border-opacity: 1 !important;
  border-bottom-color: rgba(82, 82, 82, var(--tw-border-opacity)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity)) !important;
  --tw-text-opacity: 1 !important;
  color: rgba(255, 255, 255, var(--tw-text-opacity)) !important;
}
:is(.dark .leaflet-bar a):hover {
  background-color: var(--accent-color-400) !important;
}

:is(.dark .leaflet-control-layers),:is(.dark 
.leaflet-popup-content-wrapper),:is(.dark 
.leaflet-popup-tip),:is(.dark 
.leaflet-control-attribution) {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity)) !important;
  --tw-text-opacity: 1 !important;
  color: rgba(212, 212, 212, var(--tw-text-opacity)) !important;
}

:is(.dark .leaflet-control-layers-separator) {
  --tw-border-opacity: 1 !important;
  border-top-color: rgba(82, 82, 82, var(--tw-border-opacity)) !important;
}

/** Improve Leaflet layer legend styling */
.leaflet-control-layers-overlays > label > div {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.leaflet-control-layers-overlays > label > div > span {
  display: contents;
}

.leaflet-control-layers-selector {
  position: static;
  margin: 0px;
  padding: 0px;
}

/*
 * Workaround for https://github.com/Leaflet/Leaflet/issues/6986
 * This can be removed after updating Leaflet to 1.8.0
 * REFACTOR: remove this after updating Leaflet
 */
.leaflet-container :focus {
  outline: revert !important;
}

/* The CodeMirror editor styleds*/
.cm-theme,
.cm-editor {
  height: 100%;
}
.odd\\:dark:nth-child(odd)body {
    color-scheme: dark;
  }
.after\\:invisible::after {
  content: var(--tw-content);
  visibility: hidden;
}
.after\\:block::after {
  content: var(--tw-content);
  display: block;
}
.after\\:p-2::after {
  content: var(--tw-content);
  padding: 0.5rem;
}
.after\\:px-2::after {
  content: var(--tw-content);
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.after\\:leading-\\[0px\\]::after {
  content: var(--tw-content);
  line-height: 0px;
}
.after\\:content-\\[attr\\(data-count\\)\\]::after {
  --tw-content: attr(data-count);
  content: var(--tw-content);
}
.after\\:content-\\[attr\\(data-value\\)\\]::after {
  --tw-content: attr(data-value);
  content: var(--tw-content);
}
.first\\:border-l:first-child {
  border-left-width: 1px;
}
.odd\\:\\[--bg\\:theme\\(colors\\.gray\\.100\\)\\]:nth-child(odd) {
  --bg: #f3f4f6;
}
.even\\:\\[--bg\\:transparent\\]:nth-child(even) {
  --bg: transparent;
}
@keyframes hue-rotate {
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}
.hover\\:animate-hue-rotate:hover {
  animation: 4s hue-rotate 2s linear infinite;
}
.hover\\:bg-\\[color\\:var\\(--custom-select-b2\\)\\]:hover {
  background-color: var(--custom-select-b2);
}
.hover\\:bg-brand-200:hover {
  background-color: var(--accent-color-200);
}
.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(209, 213, 219, var(--tw-bg-opacity));
}
.hover\\:\\!text-white:hover {
  --tw-text-opacity: 1 !important;
  color: rgba(255, 255, 255, var(--tw-text-opacity)) !important;
}
.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.hover\\:shadow-gray-400:hover {
  --tw-shadow-color: #9ca3af;
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:brightness-70:hover {
  --tw-brightness: brightness(.7);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:brightness-80:hover {
  --tw-brightness: brightness(.8);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:brightness-90:hover {
  --tw-brightness: brightness(.9);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.focus\\:not-sr-only:focus {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.focus\\:bg-\\[color\\:var\\(--custom-select-b2\\)\\]:focus {
  background-color: var(--custom-select-b2);
}
.active\\:bg-brand-100:active {
  background-color: var(--accent-color-100);
}
.active\\:brightness-80:active {
  --tw-brightness: brightness(.8);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.disabled\\:cursor-default:disabled {
  cursor: default;
}
.disabled\\:bg-gray-200:disabled {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}
.disabled\\:text-gray-500:disabled {
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}
.disabled\\:ring-gray-400:disabled {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(156, 163, 175, var(--tw-ring-opacity));
}
.disabled\\:ring-gray-500:disabled {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(107, 114, 128, var(--tw-ring-opacity));
}
:is(.dark .dark\\:border) {
  border-width: 1px;
}
:is(.dark .dark\\:border-b) {
  border-bottom-width: 1px;
}
:is(.dark .dark\\:border-l) {
  border-left-width: 1px;
}
:is(.dark .dark\\:border-r) {
  border-right-width: 1px;
}
:is(.dark .dark\\:border-t) {
  border-top-width: 1px;
}
:is(.dark .dark\\:\\!border-solid) {
  border-style: solid !important;
}
:is(.dark .dark\\:border-none) {
  border-style: none;
}
:is(.dark .dark\\:border-black) {
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--tw-border-opacity));
}
:is(.dark .dark\\:border-gray-500) {
  --tw-border-opacity: 1;
  border-color: rgba(107, 114, 128, var(--tw-border-opacity));
}
:is(.dark .dark\\:border-neutral-500) {
  --tw-border-opacity: 1;
  border-color: rgba(115, 115, 115, var(--tw-border-opacity));
}
:is(.dark .dark\\:border-neutral-700) {
  --tw-border-opacity: 1;
  border-color: rgba(64, 64, 64, var(--tw-border-opacity));
}
:is(.dark .dark\\:border-white) {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}
:is(.dark .dark\\:\\!bg-brand-500) {
  background-color: var(--accent-color-500) !important;
}
:is(.dark .dark\\:bg-\\[color\\:var\\(--form-background\\)\\]) {
  background-color: var(--form-background);
}
:is(.dark .dark\\:bg-black) {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-black\\/70) {
  background-color: rgba(0, 0, 0, 0.7);
}
:is(.dark .dark\\:bg-blue-800) {
  --tw-bg-opacity: 1;
  background-color: rgba(30, 64, 175, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-blue-900) {
  --tw-bg-opacity: 1;
  background-color: rgba(30, 58, 138, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-brand-500) {
  background-color: var(--accent-color-500);
}
:is(.dark .dark\\:bg-gray-800) {
  --tw-bg-opacity: 1;
  background-color: rgba(31, 41, 55, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-green-700) {
  --tw-bg-opacity: 1;
  background-color: rgba(21, 128, 61, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-neutral-100) {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 245, 245, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-neutral-500) {
  --tw-bg-opacity: 1;
  background-color: rgba(115, 115, 115, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-neutral-600) {
  --tw-bg-opacity: 1;
  background-color: rgba(82, 82, 82, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-neutral-700) {
  --tw-bg-opacity: 1;
  background-color: rgba(64, 64, 64, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-neutral-800) {
  --tw-bg-opacity: 1;
  background-color: rgba(38, 38, 38, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-neutral-900) {
  --tw-bg-opacity: 1;
  background-color: rgba(23, 23, 23, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-neutral-900\\/70) {
  background-color: rgba(23, 23, 23, 0.7);
}
:is(.dark .dark\\:bg-red-800) {
  --tw-bg-opacity: 1;
  background-color: rgba(153, 27, 27, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-red-900) {
  --tw-bg-opacity: 1;
  background-color: rgba(127, 29, 29, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-transparent) {
  background-color: transparent;
}
:is(.dark .dark\\:bg-yellow-800) {
  --tw-bg-opacity: 1;
  background-color: rgba(133, 77, 14, var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-yellow-900) {
  --tw-bg-opacity: 1;
  background-color: rgba(113, 63, 18, var(--tw-bg-opacity));
}
:is(.dark .dark\\:from-neutral-800) {
  --tw-gradient-from: #262626 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(38, 38, 38, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
:is(.dark .dark\\:via-neutral-900) {
  --tw-gradient-to: rgba(23, 23, 23, 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #171717 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
:is(.dark .dark\\:to-neutral-900) {
  --tw-gradient-to: #171717 var(--tw-gradient-to-position);
}
:is(.dark .dark\\:stroke-neutral-700) {
  stroke: #404040;
}
:is(.dark .dark\\:text-blue-100) {
  --tw-text-opacity: 1;
  color: rgba(219, 234, 254, var(--tw-text-opacity));
}
:is(.dark .dark\\:text-brand-400) {
  color: var(--accent-color-400);
}
:is(.dark .dark\\:text-gray-100) {
  --tw-text-opacity: 1;
  color: rgba(243, 244, 246, var(--tw-text-opacity));
}
:is(.dark .dark\\:text-gray-200) {
  --tw-text-opacity: 1;
  color: rgba(229, 231, 235, var(--tw-text-opacity));
}
:is(.dark .dark\\:text-neutral-200) {
  --tw-text-opacity: 1;
  color: rgba(229, 229, 229, var(--tw-text-opacity));
}
:is(.dark .dark\\:text-neutral-350) {
  --tw-text-opacity: 1;
  color: hsla(0, 0%, 73%, var(--tw-text-opacity));
}
:is(.dark .dark\\:text-neutral-400) {
  --tw-text-opacity: 1;
  color: rgba(163, 163, 163, var(--tw-text-opacity));
}
:is(.dark .dark\\:text-neutral-500) {
  --tw-text-opacity: 1;
  color: rgba(115, 115, 115, var(--tw-text-opacity));
}
:is(.dark .dark\\:text-red-100) {
  --tw-text-opacity: 1;
  color: rgba(254, 226, 226, var(--tw-text-opacity));
}
:is(.dark .dark\\:text-white) {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
:is(.dark .dark\\:text-yellow-100) {
  --tw-text-opacity: 1;
  color: rgba(254, 249, 195, var(--tw-text-opacity));
}
:is(.dark .dark\\:\\!ring-2) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0)) !important;
}
:is(.dark .dark\\:ring) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
:is(.dark .dark\\:ring-0) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
:is(.dark .dark\\:\\!ring-brand-400) {
  --tw-ring-color: var(--accent-color-400) !important;
}
:is(.dark .dark\\:ring-brand-400) {
  --tw-ring-color: var(--accent-color-400);
}
:is(.dark .dark\\:ring-neutral-600) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(82, 82, 82, var(--tw-ring-opacity));
}
:is(.dark .dark\\:brightness-125) {
  --tw-brightness: brightness(1.25);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
:is(.dark .dark\\:invert-leaflet-layer) {
    filter: brightness(0.6) invert(1) contrast(3) hue-rotate(200deg)
      saturate(0.3) brightness(0.7);
  }
:is(.dark .odd\\:dark\\:\\[--bg\\:theme\\(colors\\.neutral\\.700\\)\\]):nth-child(odd) {
  --bg: #404040;
}
:is(.dark .hover\\:dark\\:\\!bg-brand-400):hover {
  background-color: var(--accent-color-400) !important;
}
:is(.dark .hover\\:dark\\:bg-neutral-600):hover {
  --tw-bg-opacity: 1;
  background-color: rgba(82, 82, 82, var(--tw-bg-opacity));
}
:is(.dark .hover\\:dark\\:bg-neutral-700):hover {
  --tw-bg-opacity: 1;
  background-color: rgba(64, 64, 64, var(--tw-bg-opacity));
}
:is(.dark .dark\\:hover\\:text-gray-200:hover) {
  --tw-text-opacity: 1;
  color: rgba(229, 231, 235, var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:brightness-125:hover) {
  --tw-brightness: brightness(1.25);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
:is(.dark .dark\\:hover\\:brightness-150:hover) {
  --tw-brightness: brightness(1.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
:is(.dark .dark\\:active\\:bg-brand-500:active) {
  background-color: var(--accent-color-500);
}
:is(.dark .dark\\:disabled\\:\\!bg-neutral-700:disabled) {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(64, 64, 64, var(--tw-bg-opacity)) !important;
}
:is(.dark .disabled\\:dark\\:ring-neutral-500):disabled {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(115, 115, 115, var(--tw-ring-opacity));
}
@media (min-width: 640px) {
  .sm\\:block {
    display: block;
  }
  .sm\\:h-0 {
    height: 0px;
  }
  .sm\\:h-full {
    height: 100%;
  }
  .sm\\:max-h-\\[50\\%\\] {
    max-height: 50%;
  }
  .sm\\:min-h-0 {
    min-height: 0px;
  }
  .sm\\:min-w-\\[unset\\] {
    min-width: initial;
  }
  .sm\\:max-w-md {
    max-width: 28rem;
  }
  .sm\\:flex-1 {
    flex: 1 1 0%;
  }
  .sm\\:grid-rows-\\[100\\%_100\\%\\] {
    grid-template-rows: 100% 100%;
  }
  .sm\\:flex-row {
    flex-direction: row;
  }
  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }
  .sm\\:overflow-hidden {
    overflow: hidden;
  }
  .sm\\:overflow-visible {
    overflow: visible;
  }
  .sm\\:overflow-scroll {
    overflow: scroll;
  }
  .sm\\:overflow-y-auto {
    overflow-y: auto;
  }
  .sm\\:overflow-x-visible {
    overflow-x: visible;
  }
  .sm\\:p-4 {
    padding: 1rem;
  }
}
@media (min-width: 768px) {
  .md\\:sticky {
    position: sticky;
  }
  .md\\:block {
    display: block;
  }
  .md\\:flex {
    display: flex;
  }
  .md\\:contents {
    display: contents;
  }
  .md\\:w-60 {
    width: 15rem;
  }
  .md\\:min-w-\\[theme\\(spacing\\.64\\)\\] {
    min-width: 16rem;
  }
  .md\\:min-w-\\[theme\\(spacing\\.80\\)\\] {
    min-width: 20rem;
  }
  .md\\:min-w-\\[unset\\] {
    min-width: initial;
  }
  .md\\:max-w-\\[33vw\\] {
    max-width: 33vw;
  }
  .md\\:flex-1 {
    flex: 1 1 0%;
  }
  .md\\:grid-cols-\\[auto_1fr_auto_1fr\\] {
    grid-template-columns: auto 1fr auto 1fr;
  }
  .md\\:flex-row {
    flex-direction: row;
  }
  .md\\:flex-col {
    flex-direction: column;
  }
  .md\\:items-stretch {
    align-items: stretch;
  }
  .md\\:justify-between {
    justify-content: space-between;
  }
  .md\\:gap-2 {
    gap: 0.5rem;
  }
  .md\\:gap-4 {
    gap: 1rem;
  }
  .md\\:gap-8 {
    gap: 2rem;
  }
  .md\\:overflow-hidden {
    overflow: hidden;
  }
  .md\\:text-center {
    text-align: center;
  }
  .md\\:text-right {
    text-align: right;
  }
}
@media (min-width: 1024px) {
  .lg\\:max-w-\\[50\\%\\] {
    max-width: 50%;
  }
  .lg\\:grid-cols-\\[auto_repeat\\(var\\(--columns\\)\\2c 1fr\\)\\] {
    grid-template-columns: auto repeat(var(--columns),1fr);
  }
}
@media (min-width: 1280px) {
  .xl\\:w-full {
    width: 100%;
  }
}
@media (min-width: 1536px) {
  .\\32xl\\:w-auto {
    width: auto;
  }
}
@media print {
  .print\\:m-8 {
    margin: 2rem;
  }
  .print\\:hidden {
    display: none;
  }
  .print\\:h-auto {
    height: auto;
  }
  .print\\:grid-cols-\\[min-content_auto\\] {
    grid-template-columns: min-content auto;
  }
  .print\\:gap-1 {
    gap: 0.25rem;
  }
  .print\\:overflow-auto {
    overflow: auto;
  }
  .print\\:p-1 {
    padding: 0.25rem;
  }
  .print\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .print\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
.\\[\\&\\:not\\(\\:hover\\)\\]\\:\\!text-brand-300:not(:hover) {
  color: var(--accent-color-300) !important;
}
:is(.dark .\\[\\&\\:not\\(\\:hover\\)\\]\\:dark\\:\\!text-brand-400):not(:hover) {
  color: var(--accent-color-400) !important;
}
.\\[\\&\\:not\\(\\[aria-current\\]\\)\\:not\\(\\:hover\\)\\]\\:\\!text-neutral-500:not([aria-current]):not(:hover) {
  --tw-text-opacity: 1 !important;
  color: rgba(115, 115, 115, var(--tw-text-opacity)) !important;
}
.\\[\\&\\>\\*\\]\\:flex-1>* {
  flex: 1 1 0%;
}
.\\[\\&\\>li\\]\\:contents>li {
  display: contents;
}
.\\[\\&_\\:is\\(td\\2c th\\)\\:nth-child\\(2\\)\\]\\:mr-1 :is(td,th):nth-child(2) {
  margin-right: 0.25rem;
}
.\\[\\&_\\:is\\(td\\2c th\\)\\:nth-child\\(2\\)\\]\\:border-r :is(td,th):nth-child(2) {
  border-right-width: 1px;
}
.\\[\\&_\\:is\\(td\\2c th\\)\\:nth-child\\(2\\)\\]\\:border-gray-500 :is(td,th):nth-child(2) {
  --tw-border-opacity: 1;
  border-color: rgba(107, 114, 128, var(--tw-border-opacity));
}
.\\[\\&_\\:is\\(td\\2c th\\)\\:nth-child\\(2\\)\\]\\:pr-2 :is(td,th):nth-child(2) {
  padding-right: 0.5rem;
}
.\\[\\&_\\:is\\(td\\2c th\\)\\]\\:border-gray-500 :is(td,th) {
  --tw-border-opacity: 1;
  border-color: rgba(107, 114, 128, var(--tw-border-opacity));
}
.\\[\\&_\\:is\\(td\\2c th\\)\\]\\:p-2 :is(td,th) {
  padding: 0.5rem;
}
.\\[\\&_\\:is\\(th\\2c td\\)\\]\\:border-b :is(th,td) {
  border-bottom-width: 1px;
}
.\\[\\&_\\:is\\(th\\2c td\\)\\]\\:p-1 :is(th,td) {
  padding: 0.25rem;
}
.\\[\\&_\\:is\\(th\\2c td\\)\\]\\:pr-2 :is(th,td) {
  padding-right: 0.5rem;
}
@media (min-width: 640px) {
  .sm\\:\\[\\&_\\:is\\(th\\2c td\\)\\]\\:pr-4 :is(th,td) {
    padding-right: 1rem;
  }
}
.hover\\:\\[\\&_a\\.link\\]\\:text-brand-300 a.link:hover {
  color: var(--accent-color-300);
}
.\\[\\&_input\\]\\:max-w-\\[min\\(100\\%\\2c var\\(--max-field-width\\)\\)\\] input {
  max-width: min(100%,var(--max-field-width));
}
.\\[\\&_tbody_\\:is\\(td\\2c th\\)\\]\\:border tbody :is(td,th) {
  border-width: 1px;
}
.\\[\\&_tbody_\\:is\\(td\\2c th\\)\\]\\:border-gray-300 tbody :is(td,th) {
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}
:is(.dark .dark\\:\\[\\&_tbody_\\:is\\(td\\2c th\\)\\]\\:border-neutral-700 tbody :is(td,th)) {
  --tw-border-opacity: 1;
  border-color: rgba(64, 64, 64, var(--tw-border-opacity));
}
.\\[\\&_tbody_td\\]\\:break-words tbody td {
  overflow-wrap: break-word;
}
.\\[\\&_td\\]\\:\\!items-stretch td {
  align-items: stretch !important;
}
.\\[\\&_textarea\\]\\:resize-y textarea {
  resize: vertical;
}
.\\[\\&_thead_\\:is\\(td\\2c th\\)\\]\\:bg-gray-300 thead :is(td,th) {
  --tw-bg-opacity: 1;
  background-color: rgba(209, 213, 219, var(--tw-bg-opacity));
}
:is(.dark .\\[\\&_thead_\\:is\\(td\\2c th\\)\\]\\:dark\\:bg-neutral-700) thead :is(td,th) {
  --tw-bg-opacity: 1;
  background-color: rgba(64, 64, 64, var(--tw-bg-opacity));
}
* .\\[\\*_\\&\\:first-child\\]\\:rounded-bl:first-child {
  border-bottom-left-radius: 0.375rem;
}
.motion-normal .\\[\\.motion-normal_\\&\\]\\:m-px {
  margin: 1px;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.motion-normal .\\[\\.motion-normal_\\&\\]\\:animate-spin {
  animation: spin 1s linear infinite;
}
.motion-normal .\\[\\.motion-normal_\\&\\]\\:border-r-transparent {
  border-right-color: transparent;
}
@keyframes hue-rotate {
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}
.reduce-motion .\\[\\.reduce-motion_\\&\\]\\:animate-hue-rotate {
  animation: 4s hue-rotate 2s linear infinite;
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
body:not(.reduce-motion) .\\[body\\:not\\(\\.reduce-motion\\)_\\&\\]\\:animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
`, "",{"version":3,"sources":["webpack://./css/main.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;;CAAc;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAAd;EAAA,wBAAc;UAAd,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,8BAAc;AAAA;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAc;EAAd;AAAc;AAAd;EAAA,cAAc;EAAd;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA,iBAAc;EAAd;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA,cAAc;EAAd;AAAc;AAAd;EAAA,yDAAc;EAAd,wCAAc;EAAd,4BAAc;EAAd,4BAAc;EAAd,qBAAc;EAAd,iCAAc;UAAd;AAAc;AAAd;EAAA,yBAAc;EAAd,4BAAc;EAAd,0BAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,mCAAc;UAAd;AAAc;AAAd;EAAA,wBAAc;UAAd,gBAAc;EAAd,UAAc;EAAd,iCAAc;UAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd;AAAc;AAAd;EAAA,yDAAc;AAAA;AAAd;EAAA;IAAA,wBAAc;YAAd;EAAc;AAAA;AAAd;EAAA,yDAAc;AAAA;AAAd;EAAA;IAAA,wBAAc;YAAd;EAAc;AAAA;AAAd;EAAA,yBAAc;EAAd;AAAc;AAAd;EAAA,yDAAc;EAAd,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,4BAAc;AAAA;AAAd;EAAA;IAAA,wBAAc;YAAd;EAAc;AAAA;AAAd;EAAA,yBAAc;EAAd;AAAc;AAAd;EAAA,mBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,kBAAc;EAAd;AAAc;AAAd;EAAA,6BAAc;EAAd;AAAc;AAAd;EAAA,oCAAc;EAAd;AAAc;AAAd;IAAA,kBAAc;EAAA;AAAd;IAAA,mBAAc;EAAA;AAAd;EAAA;AAAc;AAAd;EAAA,2BAAc;EAAd;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA,wKAAc;EAAd,wJAAc;EAAd,gNAAc;EAAd,0BAAc;EAAd,+CAAc;EAAd;AAAc;AAAd;EAAA,yCAAc;EAAd,iDAAc;EAAd,6EAAc;EAAd,6EAAc;EAAd;AAAc;AAAd;IAAA;;;MAAc;IAAd;6BAAc;IAAd;2EAAc;IAAd;;6BAAc;EAAA;AAAd;;;;;;;;;;;;;;;;EAAA,uBAAc;EAAd,kBAAc;EAAd,yCAAc;EAAd,gBAAc;EAAd,kBAAc;EAAd,oBAAc;EAAd,qCAAc;EAAd,4CAAc;EAAd,uDAAc;EAAd,kEAAc;EAAd,kEAAc;EAAd,uHAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,kFAAc;EAAd,kFAAc;EAAd,oGAAc;EAAd,oBAAc;EAAd;AAAc;AAAd;;;;;;;;;;;;;;;;EAAA,qCAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,kFAAc;EAAd,kFAAc;EAAd;AAAc;AAAd;;;;;;;;;;;;;;;;EAAA,kBAAc;EAAd;AAAc;AAAd;;;;;;;;;;;;;;;;EAAA,kBAAc;EAAd;AAAc;AAAd;;;;EAAA,2GAAc;EAAd,yGAAc;EAAd,kFAAc;EAAd,kFAAc;EAAd;AAAc;AAAd;;;;EAAA,2GAAc;EAAd,yGAAc;EAAd,kFAAc;EAAd,kFAAc;EAAd;AAAc;AAAd;;;;;IAAA,iDAAc;EAAA;AAAd;EAAA;;;;IAAA,WAAc;IAAd,wBAAc;YAAd,gBAAc;IAAd;EAAc;AAAA;AAAd,gDAAc;AAAd;IAAA,yDAAc;IAAd,mCAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,oBAAc;EAAA;AAAd;;EAAA,2GAAc;EAAd,yGAAc;EAAd,kFAAc;EAAd,kFAAc;EAAd,oGAAc;EAAd,oBAAc;EAAd;AAAc;AAAd;;EAAA,2GAAc;EAAd,yGAAc;EAAd,kFAAc;EAAd,kFAAc;EAAd;AAAc;AAAd;;EAAA;AAAc;AAAd;EAAA,kDAAc;EAAd,oBAAc;EAAd;AAAc;AAAd;EAAA,oBAAc;EAAd;AAAc;AAAd;EAAA,sBAAc;EAAd,oBAAc;EAAd;AAAc;AAAd;;EAAA,eAAc;EAAd;AAAc;AAAd;;EAAA,sHAAc;EAAd,oHAAc;EAAd,6FAAc;EAAd,6FAAc;EAAd,+GAAc;EAAd;AAAc;AAAd;;EAAA;AAAc;AAAd;;EAAA;AAAc;AAAd;EAAA,eAAc;EAAd,kBAAc;EAAd,2DAAc;EAAd,oBAAc;EAAd;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA,oBAAc;EAAd;AAAc;AAAd;EAAA,kBAAc;EAAd,wDAAc;EAAd,oBAAc;EAAd;AAAc;AAAd;;EAAA;AAAc;AAAd;;EAAA;AAAc;AAAd;;EAAA,2BAAc;EAAd;AAAc;AAAd;;EAAA,2BAAc;EAAd;AAAc;AAAd;;EAAA,WAAc;EAAd;AAAc;AAAd;EAAA;AAAc;AAAd,iCAAc;AAAd;IAAA,0BAAc;EAAA;AAAd,kCAAc;AAAd;;EAAA,WAAc;EAAd,wBAAc;UAAd;AAAc;AAAd,gCAAc;AAAd;;EAAA;AAAc;AAAd,gCAAc;AAAd;;IAAA,gDAAc;EAAA;AAAd;;IAAA,kBAAc;IAAd,UAAc;IAAd,QAAc;IAAd,YAAc;IAAd,aAAc;EAAA;AAAd;EAAA,kBAAc;EAAd;AAAc;AAAd;EAAA;AAAc;AAAd;;;EAAA,wCAAc;EAAd,gCAAc;EAAd;AAAc;AAAd;;;EAAA,gCAAc;EAAd;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA,oBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,WAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd;AAAc;AAAd;EAAA,uCAAc;UAAd;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA,sHAAc;EAAd,oHAAc;EAAd,6FAAc;EAAd,6FAAc;EAAd;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA,kCAAc;UAAd;AAAc;AAAd;EAAA,oBAAc;EAAd;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA,8BAAc;EAAd,+BAAc;EAAd;AAAc;AAAd;EAAA,+BAAc;EAAd;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA,+BAAc;EAAd;AAAc;AAAd;EAAA,+BAAc;EAAd;AAAc;AAAd;EAAA,uBAAc;EAAd,kBAAc;EAAd;AAAc;AAAd;EAAA,kBAAc;EAAd;AAAc;AAAd;EAAA,uBAAc;EAAd;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA,uBAAc;EAAd;AAAc;AAAd;EAAA;AAAc;AAAd;;;;;;;IAAc;AAAd;EAAA;AAAc;AAAd;EAAA;AAAc;AAAd;;EAAA,aAAc;EAAd,mBAAc;EAAd;AAAc;AAAd;;;IAAc;AAAd;EAAA;AAAc;AAAd;EAAA;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAEd;;;;;EAKE;;AA2OF;;;EAGE;AACF;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAGlB;IACE,8BAAsC;IACtC,uBAAuC;IACvC,kCAA2C;IAC3C,wBAA0C;IAC1C,uBAAwC;IACxC,uBAAyC;IACzC,mCAAoD;EAQtD;AAPE;EAAA,uBAMgD;EANhD,uBAMgD;EANhD,mCAMgD;EANhD,wBAMgD;EANhD,mBAMgD;EANhD,wBAMgD;EANhD;AAMgD;AAGlD;IACE,wBAAyC;IACzC,2CAA6C;IAC7C,+CAAiD;EAInD;AAHE;EAAA,+CAEqD;EAFrD,2BAEqD;EAFrD;AAEqD;AAGvD;;IAEE,2BAA4C;IAC5C,2BAA4C;IAC5C,+BAAgD;EAIlD;AAHE;;EAAA,+BAEoD;EAFpD,2BAEoD;EAFpD;AAEoD;AAGtD;;IAEE,2BAA4C;IAC5C,2BAA4C;IAC5C,0CAAgD;EAIlD;AAHE;;EAAA,2BAEuD;EAFvD,+BAEuD;EAFvD;AAEuD;;AAa3D;;;EAGE;AACF;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,8FAAmB;EAAnB,kEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB,kEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,mGAAmB;EAAnB,kEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,iFAAmB;EAAnB,iGAAmB;EAAnB,kEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,sCAAmB;EAAnB,kEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB,kEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB,6FAAmB;EAAnB,6FAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB,6FAAmB;EAAnB,6FAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,kFAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,kFAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,kFAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,kFAAmB;EAAnB,kFAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,wKAAmB;EAAnB,wJAAmB;EAAnB,gNAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAGjB;;;IAGE;AANJ;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAanB;EACE;;;;;IAKE;EACF,mBAAmB;AACrB;;AAEA,sBAAsB;AAEpB;EAAA,iCACkB;EADlB,0EACkB;EADlB,6BACkB;EADlB,gEACkB;EADlB,+BACkB;EADlB;AACkB;AADlB;EAAA;AACkB;;AAOlB;;;;EAAA,6BAA4C;EAA5C,gEAA4C;EAA5C,+BAA4C;EAA5C;AAA4C;;AAI5C;EAAA,iCAAiC;EAAjC;AAAiC;;AAGnC,0CAA0C;AAExC;EAAA,aAA8B;EAA9B,mBAA8B;EAA9B;AAA8B;;AAI9B;EAAA;AAAe;;AAIf;EAAA,gBAAqB;EAArB,WAAqB;EAArB;AAAqB;;AAGvB;;;;EAIE;AACF;EACE,0BAA0B;AAC5B;;AAEA,iCAAiC;AAG/B;;EAAA;AAAa;AA1Xf;IAAA,kBA4XA;EAAA;AA5XA;EAAA,0BA4XA;EA5XA;AA4XA;AA5XA;EAAA,0BA4XA;EA5XA;AA4XA;AA5XA;EAAA,0BA4XA;EA5XA;AA4XA;AA5XA;EAAA,0BA4XA;EA5XA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,0BA4XA;EA5XA;AA4XA;AA5XA;EAAA,8BA4XA;EA5XA;AA4XA;AA5XA;EAAA,8BA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;AAAA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,+BA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,iFA4XA;EA5XA,iGA4XA;EA5XA,kEA4XA;EA5XA,kEA4XA;EA5XA;AA4XA;AA5XA;EAAA,0BA4XA;EA5XA;AA4XA;AA5XA;EAAA,+BA4XA;EA5XA;AA4XA;AA5XA;EAAA,+BA4XA;EA5XA;AA4XA;AA5XA;EAAA,+BA4XA;EA5XA;AA4XA;AA5XA;EAAA,gBA4XA;EA5XA,WA4XA;EA5XA,YA4XA;EA5XA,UA4XA;EA5XA,SA4XA;EA5XA,iBA4XA;EA5XA,UA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,+BA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,sBA4XA;EA5XA;AA4XA;AA5XA;EAAA,sBA4XA;EA5XA;AA4XA;AA5XA;EAAA,sBA4XA;EA5XA;AA4XA;AA5XA;EAAA,sBA4XA;EA5XA;AA4XA;AA5XA;EAAA,sBA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,4DA4XA;EA5XA,oEA4XA;EA5XA;AA4XA;AA5XA;EAAA,qEA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,sHA4XA;EA5XA,oHA4XA;EA5XA,6FA4XA;EA5XA,6FA4XA;EA5XA;AA4XA;AA5XA;EAAA,2GA4XA;EA5XA,yGA4XA;EA5XA,kFA4XA;EA5XA,kFA4XA;EA5XA;AA4XA;AA5XA;EAAA,2GA4XA;EA5XA,yGA4XA;EA5XA,kFA4XA;EA5XA,kFA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,iCA4XA;EA5XA;AA4XA;AA5DE;IACE;mCAC+B;EACjC;AAnUF;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA,iCA4XA;EA5XA;AA4XA;AA5XA;EAAA,gCA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,6BA4XA;EA5XA;AA4XA;AA5XA;EAAA,oBA4XA;EA5XA;AA4XA;AA5XA;EAAA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;AAAA;AA5XA;EAAA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;AAAA;AA5XA;EAAA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;AAAA;AA5XA;EAAA;IAAA;EA4XA;AAAA;AA5XA;EAAA;IAAA;EA4XA;AAAA;AA5XA;EAAA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;EA5XA;IAAA,qBA4XA;IA5XA;EA4XA;EA5XA;IAAA,kBA4XA;IA5XA;EA4XA;AAAA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,+BA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,sBA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,sBA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;IAAA;EA4XA;AAAA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,sBA4XA;EA5XA;AA4XA;AA5XA;EAAA,sBA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA,kBA4XA;EA5XA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;IAAA;EA4XA;AAAA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;IAAA;EA4XA;EA5XA;IAAA;EA4XA;AAAA;AA5XA;EAAA;AA4XA;AA5XA;EAAA;IAAA;EA4XA;AAAA;AA5XA;EAAA;AA4XA","sourcesContent":["/**\n * This injects Tailwind's base styles and any base styles registered by\n * plugins.\n */\n@tailwind base;\n\n/*\n * REFACTOR: get rid of most global styles once everything is using React components\n *   (can use arbitrary variants too)\n * REFACTOR: remove most usages of !important after global styles are removed\n * REFACTOR: split this into smaller files\n */\n@layer base {\n  body.reduce-motion * {\n    @apply !transition-none !duration-0;\n  }\n\n  body.dark {\n    color-scheme: dark;\n  }\n\n  body:not(.dark) {\n    color-scheme: light;\n  }\n\n  body.no-rounded-corners *:not(.rounded-full) {\n    @apply !rounded-none;\n  }\n\n  * {\n    @apply placeholder-gray-400 !ring-inset transition\n      duration-[var(--transition-duration)] ease-in-out dark:!shadow-none;\n    /*\n     * Disables transitions for text color.\n     * See https://github.com/specify/specify7/issues/1561\n     */\n    transition-property: background-color, border-color, text-decoration-color,\n      fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  }\n\n  [type='text'],\n  [type='email'],\n  [type='url'],\n  [type='password'],\n  [type='number'],\n  [type='date'],\n  [type='datetime-local'],\n  [type='month'],\n  [type='search'],\n  [type='tel'],\n  [type='time'],\n  [type='week'],\n  [multiple],\n  textarea,\n  .textarea-shadow,\n  select {\n    @apply accent-brand-200 dark:accent-brand-400 rounded border-none bg-[color:var(--field-background)] p-1\n      text-[length:inherit] leading-[unset] shadow-sm ring-1\n      ring-gray-400 dark:ring-0\n      [.has-alt-background_&]:optional:bg-white\n      dark:[.has-alt-background_&]:optional:bg-neutral-900;\n  }\n\n  input,\n  textarea,\n  .textarea-shadow,\n  select {\n    @apply focus:ring-2 dark:focus:ring-1;\n\n    /* Hide arrows, calendar icon and other symbols */\n    @apply print:m-0 print:appearance-none print:bg-none;\n  }\n\n  /* Adapted from Tailwind's styles for <select> */\n  input.autocomplete {\n    background-image: url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e');\n    background-position: right 0 center;\n    background-repeat: no-repeat;\n    background-size: 1.5em 1.5em;\n    padding-right: 1.5em;\n  }\n\n  :disabled:not(.link),\n  [readonly] {\n    @apply ring-1 ring-gray-500 dark:ring-1;\n  }\n\n  select,\n  input[role='combox'] {\n    @apply disabled:cursor-default;\n  }\n\n  :is(:disabled, [readonly]):not(.link, [type='checkbox'], [type='radio']) {\n    @apply bg-[color:var(--disabled-field-background)] text-gray-700\n      dark:text-neutral-500;\n  }\n\n  select[size] {\n    @apply bg-none pl-2 pr-1;\n  }\n\n  [type='checkbox'],\n  [type='radio'] {\n    @apply text-brand-200 dark:text-brand-400 cursor-pointer focus:border-none focus:!ring-2\n      focus:!ring-offset-0;\n  }\n\n  :is([type='checkbox'], [type='radio']):is([readonly], :disabled) {\n    @apply cursor-default bg-gray-300 text-gray-500 checked:bg-current hover:ring-gray-500\n      dark:bg-neutral-600 dark:text-neutral-900;\n  }\n\n  label,\n  summary {\n    @apply cursor-pointer;\n  }\n\n  form:not(.not-submitted) :is(input, select, textarea):invalid,\n  :is(input, select, textarea):not(.not-touched):invalid {\n    @apply !bg-[color:var(--invalid-field-background)] placeholder-red-900\n      dark:placeholder-red-400;\n  }\n\n  textarea,\n  .textarea-shadow {\n    @apply w-full resize;\n  }\n\n  :required {\n    @apply bg-[color:var(--required-field-background)];\n  }\n\n  /* Hide up/down arrows in Gecko */\n  [type='number'].no-arrows {\n    -moz-appearance: textfield;\n  }\n\n  /* Hide up/down arrows in Webkit */\n  [type='number'].no-arrows::-webkit-outer-spin-button,\n  [type='number'].no-arrows::-webkit-inner-spin-button {\n    @apply m-0 appearance-none;\n  }\n\n  /* Always show spinner buttons */\n  [type='number']:not([readonly], .no-arrows)::-webkit-inner-spin-button,\n  [type='number']:not([readonly], .no-arrows)::-webkit-outer-spin-button {\n    @apply opacity-100;\n  }\n\n  /* Make spinner buttons larger */\n  [type='number']:not([readonly], .no-arrows)::-webkit-outer-spin-button,\n  [type='number']:not([readonly], .no-arrows)::-webkit-inner-spin-button {\n    -webkit-appearance: inner-spin-button !important;\n    @apply absolute right-0 top-0 h-full w-2;\n  }\n\n  [type='number']:not([readonly], .no-arrows) {\n    @apply relative pr-4;\n  }\n\n  .button {\n    @apply text-center;\n  }\n\n  .button:is([aria-pressed='true'], [aria-selected='true'], [aria-current]):not(\n      .aria-handled\n    ) {\n    @apply ring-[color:var(--accent-color-300)] brightness-[1.2] dark:brightness-[1.5];\n  }\n\n  button[aria-pressed='true']:not(.aria-handled).link {\n    @apply text-brand-300 dark:text-brand-400 !bg-transparent;\n  }\n\n  a.button {\n    @apply text-center;\n  }\n\n  .link {\n    @apply enabled:hover:text-brand-300 inline-flex cursor-pointer items-center\n      gap-2 text-left text-black active:underline\n      disabled:cursor-text disabled:!ring-0 disabled:active:no-underline\n      dark:text-gray-200;\n  }\n\n  a.link {\n    @apply hover:text-brand-400 dark:hover:text-brand-300;\n  }\n\n  .link[aria-current]:not(.aria-handled) {\n    @apply text-brand-300;\n  }\n\n  .icon {\n    @apply active:bg-brand-100 dark:active:bg-brand-500\n      disabled:!cursor-not-allowed disabled:!text-gray-400\n      disabled:hover:!text-gray-400 disabled:dark:!text-neutral-600\n      disabled:hover:dark:!text-neutral-600;\n  }\n\n  progress::-webkit-progress-bar {\n    @apply rounded bg-gray-200 dark:bg-neutral-700;\n  }\n\n  progress::-webkit-progress-value {\n    @apply bg-brand-200 dark:bg-brand-400 rounded;\n  }\n\n  progress::-moz-progress-bar {\n    @apply bg-brand-200 dark:bg-brand-400 rounded;\n  }\n\n  /*\n   * Grid-based table implementation for increased flexibility\n   * Does not sacrifice accessibility thanks to the [role] attributes\n   * Allows for things like sticky headers and having entire row be a link/button\n   * You can set column sizes by adding a className like this:\n   *   grid-cols-[repeat(4,1fr)_auto_auto_min-content_minmax(10rem,1fr)]\n   * There is much more flexibility in how columns should be sized.\n   */\n  .grid-table:is(table, [role~='table']) {\n    @apply grid;\n  }\n\n  .grid-table :is(thead, tbody, tr, [role~='rowgroup'], [role~='row']) {\n    @apply contents;\n  }\n\n  .grid-table\n    :is(th, td, [role~='columnheader'], [role~='rowheader'], [role~='cell']) {\n    @apply flex items-center gap-1;\n  }\n\n  /*\n   * Without this, sr-only elements where causing scroll bars to appear in\n   * some browsers\n   */\n  .sr-only {\n    @apply top-0;\n  }\n\n  optgroup {\n    @apply font-bold;\n  }\n}\n\n/**\n * This injects Tailwind's component classes and any component classes\n * registered by plugins.\n */\n@tailwind components;\n\n@layer components {\n  .wbs-form {\n    --new-cell: theme('colors.indigo.350');\n    --invalid-cell: theme('colors.red.300');\n    --modified-cell: theme('colors.yellow.250');\n    --search-result: theme('colors.green.300');\n    --updated-cell: theme('colors.cyan.200');\n    --deleted-cell: theme('colors.amber.500');\n    --matched-and-changed-cell: theme('colors.blue.200');\n    @apply dark:[--deleted-cell:theme('colors.amber.600')]\n      dark:[--invalid-cell:theme('colors.red.900')]\n      dark:[--matched-and-changed-cell:theme('colors.fuchsia.700')]\n      dark:[--modified-cell:theme('colors.yellow.900')]\n      dark:[--new-cell:theme('colors.indigo.900')]\n      dark:[--search-result:theme('colors.green.900')]\n      dark:[--updated-cell:theme('colors.cyan.800')];\n  }\n\n  .custom-select {\n    --custom-select-b1: theme('colors.white');\n    --custom-select-b2: theme('colors.brand.100');\n    --custom-select-accent: theme('colors.brand.100');\n    @apply dark:[--custom-select-accent:theme('colors.brand.500')]\n      dark:[--custom-select-b1:theme('colors.neutral.800')]\n      dark:[--custom-select-b2:theme('colors.brand.500')];\n  }\n\n  .custom-select-group-required-fields,\n  .custom-select-input-required {\n    --custom-select-b1: theme('colors.cyan.100');\n    --custom-select-b2: theme('colors.cyan.200');\n    --custom-select-accent: theme('colors.cyan.300');\n    @apply dark:[--custom-select-accent:theme('colors.cyan.700')]\n      dark:[--custom-select-b1:theme('colors.cyan.900')]\n      dark:[--custom-select-b2:theme('colors.cyan.800')];\n  }\n\n  .custom-select-group-hidden-fields,\n  .custom-select-input-hidden {\n    --custom-select-b1: theme('colors.gray.200');\n    --custom-select-b2: theme('colors.gray.300');\n    --custom-select-accent: theme('colors.gray.350');\n    @apply dark:[--custom-select-b1:theme('colors.neutral.800')]\n      dark:[--custom-select-accent:theme('colors.neutral.600')]\n      dark:[--custom-select-b2:theme('colors.neutral.700')];\n  }\n\n  .custom-select-group-suggested-mappings {\n    --custom-select-b1: theme('colors.green.200');\n    --custom-select-b2: theme('colors.green.300');\n    --custom-select-accent: theme('colors.green.400');\n    @apply dark:[--custom-select-accent:theme('colors.green.500')]\n      dark:[--custom-select-b1:theme('colors.green.700')]\n      dark:[--custom-select-b2:theme('colors.green.600')];\n  }\n}\n\n/**\n * This injects Tailwind's utility classes and any utility classes registered\n * by plugins.\n */\n@tailwind utilities;\n\n@layer utilities {\n  /*\n   * Smartly inverts leaflet layer's color scheme. Source:\n   * https://gist.github.com/BrendonKoz/b1df234fe3ee388b402cd8e98f7eedbd\n   */\n  .invert-leaflet-layer {\n    filter: brightness(0.6) invert(1) contrast(3) hue-rotate(200deg)\n      saturate(0.3) brightness(0.7);\n  }\n}\n\n.\\! {\n  /**\n   * In Chrome DevTools, in the \"Element Classes\" box (where you customize\n   * element class names), DevTools apply the first matching class name even\n   * before you started typing. The first matching happens to be !absolute,\n   * which breaks the UI. This noop is a workaround for that UX issue\n   */\n  --dev-tools-hack: 0;\n}\n\n/* Leaflet dark mode */\n.leaflet-bar a {\n  @apply hover:dark:!bg-brand-400 dark:!border-b-neutral-600 dark:!bg-black\n    dark:!text-white;\n}\n\n.leaflet-control-layers,\n.leaflet-popup-content-wrapper,\n.leaflet-popup-tip,\n.leaflet-control-attribution {\n  @apply dark:!bg-black dark:!text-neutral-300;\n}\n\n.leaflet-control-layers-separator {\n  @apply dark:!border-t-neutral-600;\n}\n\n/** Improve Leaflet layer legend styling */\n.leaflet-control-layers-overlays > label > div {\n  @apply flex items-center gap-2;\n}\n\n.leaflet-control-layers-overlays > label > div > span {\n  @apply contents;\n}\n\n.leaflet-control-layers-selector {\n  @apply static m-0 p-0;\n}\n\n/*\n * Workaround for https://github.com/Leaflet/Leaflet/issues/6986\n * This can be removed after updating Leaflet to 1.8.0\n * REFACTOR: remove this after updating Leaflet\n */\n.leaflet-container :focus {\n  outline: revert !important;\n}\n\n/* The CodeMirror editor styleds*/\n.cm-theme,\n.cm-editor {\n  @apply h-full;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
